module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18NtgQI/CoverDesign.jpg?1684514754109",
      "alt": "This image is the cover for the book The Midnight Gardener, The Town of Superstition"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Midnight Gardener, The Town of Superstition\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("The Town of Superstition: Book One")])])]), _c('p', [_vm._v("At fifteen, Thaddeus Cane has moved thirty-two times with his father. Each time he’s displaced without explanation, Thaddeus loses any friends he’s made. The name of their latest town is Superstition, but it seems normal enough, with one exception.")]), _vm._v(" "), _c('p', [_vm._v("Thaddeus’s bedroom window gives him a view into the beautiful gardens next door. Every night after dark, an attractive guy around Thaddeus’s age appears to tend the plants. When Thaddeus visits his neighbor, he discovers not only how deep his interest in the other man runs, but also that Teofil, the midnight gardener, isn’t human. He’s a garden gnome, a revelation that will lead to more secrets coming to light and an adventure unlike anything Thaddeus ever imagined.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      R. G. Thomas\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harmony Ink Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0